import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { 
  BarChart3, 
  TrendingUp, 
  ChevronRight
} from 'lucide-react';
import { projectsApi } from '../lib/api';
import { Card } from '../components/ui/Card';
import { LoadingSpinner } from '../components/LoadingScreen';
import { useTelegram } from '../hooks/useTelegram';

export function StatsPage() {
  const navigate = useNavigate();
  const { hapticFeedback } = useTelegram();

  const { data: projects, isLoading } = useQuery({
    queryKey: ['projects'],
    queryFn: projectsApi.list,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Фильтруем проекты где есть права на просмотр KPI
  const projectsWithAccess = projects?.filter(p => 
    ['ADMIN', 'MANAGER'].includes(p.role)
  ) || [];

  return (
    <div className="pb-24">
      <div className="p-4 bg-tg-secondary-bg">
        <h1 className="text-2xl font-bold text-tg-text">KPI и статистика</h1>
        <p className="text-tg-hint mt-1">Выберите проект для просмотра</p>
      </div>

      <div className="p-4 space-y-3">
        {projectsWithAccess.length === 0 ? (
          <div className="text-center py-12">
            <BarChart3 className="w-16 h-16 mx-auto text-tg-hint mb-4" />
            <p className="text-tg-hint">
              У вас нет доступа к статистике проектов
            </p>
          </div>
        ) : (
          projectsWithAccess.map((project) => (
            <Card
              key={project.id}
              variant="interactive"
              onClick={() => {
                hapticFeedback('light');
                navigate(`/projects/${project.id}/kpi`);
              }}
              className="p-4"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-tg-button/10 flex items-center justify-center">
                    <TrendingUp className="w-5 h-5 text-tg-button" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-tg-text">{project.name}</h3>
                    <p className="text-sm text-tg-hint">
                      {project.protocolsCount} протоколов
                    </p>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-tg-hint" />
              </div>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}

